module.exports = __webpack_public_path__ + "img/stonesize-2.8d5262e.webp";